function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContentCopyFilled = function SvgContentCopyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "15 14 14 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M27.526 16.909h-8.105a1.464 1.464 0 0 0-1.474 1.455v10.181A1.463 1.463 0 0 0 19.421 30h8.105A1.464 1.464 0 0 0 29 28.545V18.364a1.463 1.463 0 0 0-1.474-1.455ZM25.316 14h-8.842A1.464 1.464 0 0 0 15 15.455v10.181h1.474V15.455h8.842V14Z",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgContentCopyFilled;